/**
 * Elementor Tab URL Switcher
 * Allows switching Elementor tabs via URL query parameters
 * Usage: ?tab=1, ?tab=2, etc.
 * Pure JavaScript - No jQuery dependency
 */

(function() {
    'use strict';

    /**
     * Activate tab based on URL parameter
     */
    function activateTabFromURL() {
        // Get URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const tabIndex = urlParams.get('tab');

        // Exit if no tab parameter
        if (!tabIndex) {
            return;
        }

        // Find the target tab button by data-tab-index
        const targetButton = document.querySelector(`.e-n-tab-title[data-tab-index="${tabIndex}"]`);

        if (targetButton) {
            // Smooth scroll to the tab container
            const tabContainer = targetButton.closest('.elementor-widget-n-tabs');
            if (tabContainer) {
                tabContainer.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'start' 
                });
            }

            // Small delay to ensure smooth scroll starts, then click
            setTimeout(function() {
                targetButton.click();
                
                // Clean up URL - remove the tab parameter
                cleanURL();
            }, 300);
        }
    }

    /**
     * Remove tab parameter from URL without page reload
     */
    function cleanURL() {
        const url = new URL(window.location);
        url.searchParams.delete('tab');
        
        // Update URL without reloading the page
        window.history.replaceState({}, document.title, url.pathname + url.hash);
    }

    /**
     * Initialize when DOM is ready
     */
    function init() {
        // Check if Elementor frontend is available
        if (typeof elementorFrontend !== 'undefined' && elementorFrontend.hooks) {
            elementorFrontend.hooks.addAction('frontend/element_ready/global', function() {
                setTimeout(activateTabFromURL, 500);
            });
        } else {
            // Fallback: wait for DOM ready
            setTimeout(activateTabFromURL, 800);
        }
    }

    // Run when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
